export const getFileUrl = (path: string | undefined | null): string => {
    if (!path || (typeof path === 'string' && path.trim() === '')) return '';

    const base = (process.env.REACT_APP_API_URL || '').replace(/\/+$/, '');
    if (!base) return '';

    if (path.startsWith('http://') || path.startsWith('https://')) {
        return path;
    }

    const normalizedPath = path.replace(/^\/+|\/+$/g, '');
    const finalPath = normalizedPath.startsWith('public-files/')
        ? normalizedPath.slice('public-files/'.length)
        : normalizedPath;

    return `${base}/public-files/${finalPath}`;
};

export const formatFileSize = (bytes: number): string => {
    if (bytes === 0) return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return `${parseFloat((bytes / Math.pow(k, i)).toFixed(2))} ${sizes[i]}`;
};